import { FC, PropsWithChildren } from 'react';

const TableTd: FC<PropsWithChildren<{ 
  size?: 'small' | 'medium',
  align?: 'left' | 'center' | 'right',
  className?: string,
}>> = ({
  size = 'small',
  align = 'left',
  children,
  className = ''
,}) => (
  <td className={`
      whitespace-pre-line border-t-[1px] border-gray-200 font-normal 
      ${{
        'small':  'py-2 px-2 text-sm',
        'medium': 'py-4 pl-4 pr-3 sm:pl-6 lg:pl-8',
      }[size]}
        first:pl-4 last:pr-4
      ${className}
    `}
  >
    <div className={`flex relative ${{
        'left': 'justify-left',
        'center': 'justify-center',
        'right': 'justify-end',
      }[align]
    }`}>
      {children}
    </div>                            
  </td>
);


export default TableTd;
